import logo from './logo.svg';
import './App.css';
import ShineOneEstate from './idea1';

function App() {
  return (
    <div className="App">
      <ShineOneEstate />
    </div>
  );
}

export default App;
